module.exports = __webpack_public_path__ + "img/img-shield.494c8137.png";